export const siteInfo = {
  name: "看料吃瓜",
  tagline: "深挖热点，复盘全貌",
  slogan: "把碎片化的瓜，理成看得懂的复盘",
  intro:
    "看料吃瓜是一个专注文娱与全网热点深度复盘的内容站点。我们不追着情绪跑，而是把事件的时间线、背景脉络、产业逻辑与多方说法摊开来，让读者自己看清完整逻辑。",
  email: "hello@kanliao-chigua.com",
  tipEmail: "tip@kanliao-chigua.com",
  since: "2021",
  editors: ["陆时宴", "江辞白", "温故", "苏晚舟", "林知夏"],
};

export const stats = [
  { label: "已发布深度复盘", value: "1,286", unit: "篇" },
  { label: "累计梳理事件时间线", value: "430", unit: "条" },
  { label: "读者订阅简报", value: "58,000", unit: "+" },
  { label: "平均单篇阅读时长", value: "7.4", unit: "分钟" },
];

export type Category = {
  slug: string;
  name: string;
  desc: string;
  icon: string;
  count: number;
};

export const categories: Category[] = [
  {
    slug: "yule-guancha",
    name: "文娱观察",
    desc: "影视、综艺、音乐与演出市场的动态拆解，关注内容本身而非噪音。",
    icon: "ri-film-line",
    count: 312,
  },
  {
    slug: "wangluo-redian",
    name: "网络热点",
    desc: "刷屏话题的来龙去脉，还原被情绪盖住的原始信息。",
    icon: "ri-fire-line",
    count: 268,
  },
  {
    slug: "chanye-luoji",
    name: "产业逻辑",
    desc: "平台规则、商业模型与利益结构，解释现象背后的推手。",
    icon: "ri-node-tree",
    count: 189,
  },
  {
    slug: "yuqing-fupan",
    name: "舆情复盘",
    desc: "一次危机如何在数小时内发酵，复盘节点与关键转折。",
    icon: "ri-line-chart-line",
    count: 156,
  },
  {
    slug: "renwu-cexie",
    name: "人物侧写",
    desc: "用公开资料拼出人物的选择逻辑，不做无依据的揣测。",
    icon: "ri-user-star-line",
    count: 143,
  },
  {
    slug: "pingtai-shengtai",
    name: "平台生态",
    desc: "内容分发、算法与创作者生态的变化，影响每一个创作者。",
    icon: "ri-apps-2-line",
    count: 118,
  },
];

export type ArticleSection = {
  heading: string;
  paragraphs: string[];
};

export type TimelineItem = {
  at: string;
  text: string;
};

export type Article = {
  slug: string;
  title: string;
  dek: string;
  categorySlug: string;
  cover: string;
  author: string;
  date: string;
  readMinutes: number;
  tags: string[];
  featured?: boolean;
  keyPoints: string[];
  timeline: TimelineItem[];
  sections: ArticleSection[];
  quote?: string;
};

export const articles: Article[] = [
  {
    slug: "duanju-baofa-hangye-luoji",
    title: "短剧爆发三年：一门被算法重新定价的生意",
    dek: "从横店群演到投流团队，短剧用三年时间重塑了一条内容生产线。我们拆开它的成本结构、投放逻辑与监管节点，看看这门生意到底靠什么赚钱。",
    categorySlug: "chanye-luoji",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20magazine%20photography%20of%20film%20set%20lighting%20rig%20and%20clapperboard%20on%20warm%20cream%20background%2C%20soft%20natural%20light%2C%20muted%20terracotta%20accents%2C%20minimal%20high%20detail%20composition&width=1200&height=800&seq=duanju-cover-a1&orientation=landscape",
    author: "江辞白",
    date: "2026-08-28",
    readMinutes: 9,
    tags: ["短剧", "内容产业", "投放逻辑"],
    featured: true,
    keyPoints: [
      "短剧核心成本不在拍摄，而在投流，投放 ROI 决定项目生死。",
      "内容形态高度模块化，前三秒钩子比完整故事更被看重。",
      "监管收紧后，题材从强冲突转向现实情感与轻喜方向。",
    ],
    timeline: [
      { at: "2023 年初", text: "竖屏短剧在信息流中跑出正收益模型，投流团队开始批量复制。" },
      { at: "2023 年中", text: "大量制作公司涌入，单部制作成本被压至十万量级。" },
      { at: "2024 年", text: "监管加强内容审核，粗放题材退场，精品化被反复提及。" },
      { at: "2025 年", text: "平台推出分账与保底机制，行业开始出现稳定产能团队。" },
      { at: "2026 年", text: "短剧出海成为新增长点，本地化改编成为核心课题。" },
    ],
    quote: "短剧不是电视剧的缩短版，而是被信息流定价的一种新内容形态。",
    sections: [
      {
        heading: "被投流决定的内容形态",
        paragraphs: [
          "如果把短剧当成传统影视的缩水版，几乎一定会误判它。它的结构更像是为投放服务的素材组合：开头三秒必须有钩子，每十五到二十秒要制造一次小冲突，结尾卡在最吊人胃口的节点，引导用户付费解锁。",
          "这套结构的背后是清晰的成本逻辑。行业内普遍的说法是，投流成本可以占到总成本的六到八成，内容制作反而是相对可控的一块。也就是说，决定一部短剧能不能回本的，不是导演功力，而是投放团队能不能把素材的转化效率跑正。",
        ],
      },
      {
        heading: "模块化生产与人才流动",
        paragraphs: [
          "高度标准化带来的是人才结构变化。编剧岗位被拆成大纲、分集、台词等环节，执行导演更关注如何快速完成拍摄，摄影与灯光则沿用一套被验证过的视觉方案。",
          "这种流水线并不等于低质量，它更像早期网剧时代的那一轮工业化尝试：先用效率换规模，再在竞争中被逼着升级。当同一套爽点被反复使用，观众的耐受力会下降，题材与叙事的差异化就会重新变得重要。",
        ],
      },
      {
        heading: "监管节点与题材转向",
        paragraphs: [
          "行业真正分水岭出现在监管规则明确之后。强冲突、擦边与猎奇题材的空间迅速收窄，制作方开始把注意力转向现实情感、家庭关系与轻喜剧方向。",
          "题材转向的背后是风险的重新定价：与其赌一个可能下架的爆款，不如稳定产出一批安全且有基础受众的作品。这个选择看起来保守，实际上让行业第一次有了可预期的产能规划。",
        ],
      },
      {
        heading: "出海之后的新变量",
        paragraphs: [
          "当国内竞争进入存量阶段，出海成为新的想象力来源。但短剧的爽点高度依赖文化语境，直接翻译几乎必然水土不服，本地化改编因此成为核心能力。",
          "目前比较被认可的做法是保留节奏与结构，重写人物关系与冲突动机，让故事落在目标市场熟悉的语境里。懂结构又懂当地文化的团队，会在这轮变化里拿到溢价。",
        ],
      },
    ],
  },
  {
    slug: "zongyi-jianji-xushi-fupan",
    title: "剪辑台上的叙事：一档综艺为什么总在制造对立",
    dek: "同一天的素材，可以剪出完全相反的人物。复盘综艺剪辑的取舍逻辑，理解观众看到的\"真相\"是怎样被搭建出来的。",
    categorySlug: "yule-guancha",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20video%20editing%20timeline%20interface%20on%20monitor%20warm%20studio%20desk%20cream%20background%2C%20soft%20light%2C%20terracotta%20and%20sage%20green%20accents%2C%20clean%20minimal%20composition&width=1200&height=800&seq=zongyi-cover-b2&orientation=landscape",
    author: "陆时宴",
    date: "2026-08-21",
    readMinutes: 8,
    tags: ["综艺", "剪辑", "叙事"],
    featured: true,
    keyPoints: [
      "剪辑决定人物弧光，同一素材可以导向完全不同的公众印象。",
      "冲突是综艺的基本叙事货币，但过度剪辑会反噬嘉宾关系。",
      "观众对\"剧本感\"的敏感度在上升，真实感成为新卖点。",
    ],
    timeline: [
      { at: "录制阶段", text: "单期录制素材常达数百小时，远超成片时长。" },
      { at: "粗剪阶段", text: "编导先按主要人物线搭建叙事骨架，确定情绪走向。" },
      { at: "精剪阶段", text: "通过反应镜头与音乐强化冲突，形成播出效果。" },
      { at: "播出之后", text: "嘉宾与观众在社交平台对叙事产生二次解读。" },
    ],
    quote: "观众看到的不是发生了什么，而是剪辑师决定让观众看到什么。",
    sections: [
      {
        heading: "素材与成片之间的巨大落差",
        paragraphs: [
          "一档周播综艺，单期录制的原始素材轻松超过几百小时，而成片往往只有九十分钟上下。这意味着超过九成九的内容会被舍弃，保留什么、舍弃什么，本身就是一次强力的叙事选择。",
          "编导通常先确定这期要讲什么故事：是成长、是和解，还是对抗。叙事目标一旦确定，素材的组织方式就随之确定，无关镜头会被毫不犹豫地剪掉。",
        ],
      },
      {
        heading: "反应镜头是情绪的放大器",
        paragraphs: [
          "综艺里大量使用的反应镜头，是情绪叙事的关键工具。一句普通的话，配上他人惊讶或尴尬的表情，语义就会被彻底改变。",
          "问题在于，这类镜头往往来自不同时间点。当它们被并置在一起，观众会自然地认为它们同时发生。这种\"合理但未必真实\"的拼接，是争议最集中的地方。",
        ],
      },
      {
        heading: "观众为什么越来越敏感",
        paragraphs: [
          "随着观众对节目制作流程的了解加深，对\"剧本感\"的辨认能力明显提高。刻意制造的矛盾一旦被识破，反而会伤害节目口碑。",
          "于是制作方开始强调真实感：减少旁白引导、保留沉默与冷场、让关系推进显得更慢。真实变成了一种新的稀缺卖点。",
        ],
      },
      {
        heading: "复盘的价值在于拆解而非站队",
        paragraphs: [
          "我们复盘这类事件，并不是要去指认某个人物\"真实人品如何\"，那超出了公开信息能支撑的范围。更有意义的是理解：一档节目如何在商业目标、播出效果与嘉宾关系之间做取舍。",
          "当读者理解了这套取舍逻辑，就能在下次刷到\"高能剪辑\"时，多一层判断：这是情绪，还是事实。",
        ],
      },
    ],
  },
  {
    slug: "yingyuan-jingji-yingxiao-fupan",
    title: "票房之外的战场：一部电影上映前后的舆论节奏",
    dek: "定档、点映、口碑发酵、二次传播——一部电影的市场表现有一半写在宣发节奏里。逐节点复盘这套流程。",
    categorySlug: "yuqing-fupan",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20vintage%20cinema%20seats%20and%20projector%20beam%20on%20warm%20cream%20backdrop%2C%20soft%20light%2C%20terracotta%20tones%2C%20minimal%20elegant%20composition&width=1200&height=800&seq=yingyuan-cover-c3&orientation=landscape",
    author: "温故",
    date: "2026-08-15",
    readMinutes: 10,
    tags: ["电影", "宣发", "口碑"],
    keyPoints: [
      "定档时间本身就是一次博弈，避开强对手比抢先更重要。",
      "点映口碑是双刃剑，能放大优点也能提前耗损期待。",
      "首周口碑决定长线走势，二刷群体是关键变量。",
    ],
    timeline: [
      { at: "上映前 3 个月", text: "首支预告与主创物料释放，建立第一印象。" },
      { at: "上映前 2 周", text: "点映场次开启，口碑在小范围内开始扩散。" },
      { at: "上映首日", text: "排片占比与首日票房奠定市场预期。" },
      { at: "上映首周", text: "口碑走势决定第二周排片，长线能力在此刻分化。" },
    ],
    sections: [
      {
        heading: "定档是一场时间博弈",
        paragraphs: [
          "定档从来不是简单的日期选择。同期如果有体量更大的作品，排片空间会被显著压缩，即使影片质量不错，也可能因为没有场次而失去与观众见面的机会。",
          "因此宣发团队会反复权衡档期密度、题材差异与目标观众的重合度。有时候主动避开热门档期，反而是更理性的选择。",
        ],
      },
      {
        heading: "点映的两面性",
        paragraphs: [
          "点映可以提前积累口碑，让核心观众先形成讨论。但如果影片本身存在争议点，点映也可能提前暴露问题，让负面评价在上映前就完成扩散。",
          "是否点映、点映多少场、选择哪些城市，本质上是在赌口碑的方向。做得好的团队会用数据分析首波反馈，再决定是否加码。",
        ],
      },
      {
        heading: "首周决定长线",
        paragraphs: [
          "电影市场有一条被反复验证的规律：首周的排片与口碑，基本决定了后续的走势。上座率高的场次会被追加，表现不佳的场次会被迅速削减。",
          "在这个阶段，二刷与自发推荐变得极其重要。它们代表着超出营销投放的真实渗透，往往能带来更长的生命周期。",
        ],
      },
    ],
  },
  {
    slug: "wangluo-yaoyan-hecha-fangfa",
    title: "一条爆料如何被验证：网络传言的核查路径",
    dek: "截图、匿名账号、时间戳缺失——大多数爆料在传播链条里就已经失真。整理一套普通人也能用的核查方法。",
    categorySlug: "wangluo-redian",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20still%20life%20of%20magnifying%20glass%20over%20printed%20documents%20on%20warm%20cream%20desk%2C%20soft%20light%2C%20terracotta%20accents%2C%20clean%20analytical%20composition&width=1200&height=800&seq=yaoyan-cover-d4&orientation=landscape",
    author: "苏晚舟",
    date: "2026-08-09",
    readMinutes: 7,
    tags: ["谣言核查", "事实核验", "信息素养"],
    keyPoints: [
      "先看信源是谁，再看内容是什么，顺序不能颠倒。",
      "缺失上下文与时间戳的截图，几乎不具备核查价值。",
      "权威信源的\"沉默\"不等于默认，也不等于否认。",
    ],
    timeline: [
      { at: "第 1 小时", text: "匿名账号发布模糊截图，配以情绪化文案。" },
      { at: "第 3 小时", text: "搬运账号去除原始语境，形成二次传播。" },
      { at: "第 6 小时", text: "相关方未回应，舆论开始自行补全细节。" },
      { at: "第 24 小时", text: "原始信息被证伪，但纠正内容的传播量远低于传言。" },
    ],
    sections: [
      {
        heading: "先看信源，再看内容",
        paragraphs: [
          "绝大多数失真的爆料，问题都出在信源环节。一个没有历史记录、没有实名信息、专门发布同类内容的匿名账号，其可信度天然需要打折。",
          "先确认信源身份，再去评估内容，顺序不能颠倒。因为让人信服的往往不是证据本身，而是叙述方式，这恰恰是最容易被操纵的部分。",
        ],
      },
      {
        heading: "截图的三个致命缺陷",
        paragraphs: [
          "第一，截图可以裁剪，去掉关键上下文。第二，截图没有可靠的时间戳。第三，截图极易被修改，且修改痕迹通常不可见。",
          "因此，一张脱离原始出处的截图，几乎不具备独立核查价值。真正有价值的证据是可以在原始平台被定位、被复现的内容。",
          "当你看到\"某平台截图显示\"这类转述，第一反应应该是去找原始出处，而不是先转发。",
        ],
      },
      {
        heading: "沉默不等于默认",
        paragraphs: [
          "舆论经常把相关方的沉默解读为默认。但从公关与法务的角度，回应本身可能带来更大的二次传播风险，沉默是经过计算的选择。",
          "把沉默等同于承认，是一种常见的推理错误。它不构成任何有效证据。",
        ],
      },
    ],
  },
  {
    slug: "fensi-yingyuan-jingji-luoji",
    title: "应援经济的成本账：粉丝的钱到底花在哪",
    dek: "打投、地广、应援物料、数据维护——应援早已是一条成熟产业链。拆开这条链上的每一环，看看钱是怎么流动的。",
    categorySlug: "renwu-cexie",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20glowing%20led%20light%20sticks%20and%20banners%20at%20outdoor%20event%20warm%20cream%20ambience%2C%20soft%20bokeh%2C%20terracotta%20and%20amber%20tones%2C%20minimal%20composition&width=1200&height=800&seq=yanying-cover-e5&orientation=landscape",
    author: "林知夏",
    date: "2026-08-02",
    readMinutes: 8,
    tags: ["粉丝经济", "应援", "产业链"],
    keyPoints: [
      "应援资金规模不小，但透明度长期不足。",
      "地广与物料是最大开支，效果却难以量化。",
      "平台规则变化会直接改变打投的成本结构。",
    ],
    timeline: [
      { at: "早期", text: "应援以自发组织为主，规模小、账目粗放。" },
      { at: "扩张期", text: "出现专业站子与承包商，应援走向项目化。" },
      { at: "规范期", text: "平台限制打投玩法，资金流向被打投以外的场景吸收。" },
      { at: "当下", text: "应援更强调创意与传播效率，而非单纯堆钱。" },
    ],
    sections: [
      {
        heading: "钱花在哪些环节",
        paragraphs: [
          "应援支出主要集中在几块：城市地广投放、应援物料制作、活动场地协调、以及线上数据维护。其中地广与物料通常占比最高，因为它们能在短时间内形成视觉冲击。",
          "问题在于，这些支出的效果很难被量化。一次地广能带来多少实际关注，几乎无法被准确评估，这也让资金使用效率长期缺乏外部约束。",
        ],
      },
      {
        heading: "透明度为何难以提升",
        paragraphs: [
          "很多应援资金来自分散的粉丝集资，组织者通常是志愿性质。缺乏专业财务流程，加上信息公开的意愿不一，导致资金流向容易产生争议。",
          "一旦出现账目质疑，组织者往往选择解散或沉默，这进一步损害了整体信任。近年一些团队开始主动公示明细，算是往好的方向走。",
        ],
      },
      {
        heading: "规则变化带来的连锁反应",
        paragraphs: [
          "当平台限制打投类玩法之后，原本用于数据维护的预算被重新分配。部分资金转向线下体验与创意内容，应援形态因此发生了明显变化。",
          "这说明应援经济的结构，很大程度上由平台规则塑造。理解规则，才能真正理解粉丝行为的变化。",
        ],
      },
    ],
  },
  {
    slug: "zhibo-daihuo-yuqing-fupan",
    title: "一场直播翻车的四小时：舆情发酵的完整链路",
    dek: "从一句口误到全网热搜，只用了四小时。逐小时复盘这次舆情的触发点、放大器与降温机制。",
    categorySlug: "yuqing-fupan",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20empty%20live%20stream%20studio%20with%20ring%20light%20and%20microphone%20warm%20cream%20backdrop%2C%20soft%20light%2C%20terracotta%20accents%2C%20clean%20minimal%20composition&width=1200&height=800&seq=zhibo-cover-f6&orientation=landscape",
    author: "陆时宴",
    date: "2026-07-26",
    readMinutes: 9,
    tags: ["直播", "舆情", "危机公关"],
    keyPoints: [
      "首个二次传播账号决定舆情走向的量级。",
      "切片账号是最大放大器，速度远超官方回应。",
      "情绪峰值前的黄金一小时，决定了后续的降温难度。",
    ],
    timeline: [
      { at: "T+0 分钟", text: "直播中出现争议表述，实时弹幕开始密集刷屏。" },
      { at: "T+25 分钟", text: "首个切片账号发布短视频，播放量快速攀升。" },
      { at: "T+90 分钟", text: "多个搬运账号跟进，话题进入平台热榜。" },
      { at: "T+4 小时", text: "官方发布说明，但传播量级已被舆情反超。" },
    ],
    quote: "危机的黄金窗口，往往在官方意识到问题之前就已经关闭了。",
    sections: [
      {
        heading: "触发点往往不是最严重的问题",
        paragraphs: [
          "很多舆情的起点，事后看都是轻微的表述失误。真正让它升级的，是这句话是否容易被截取成一段可以独立传播的片段。",
          "可被切片的争议，传播效率远高于需要解释的复杂事实。这是理解舆情爆发的第一把钥匙。",
        ],
      },
      {
        heading: "切片账号是最大的放大器",
        paragraphs: [
          "切片与搬运账号构成了舆情的中间层。它们不生产信息，只负责把最有情绪张力的部分抽离出来，配上一句引导性文案，然后推给更大的受众。",
          "这一层的反应速度通常以分钟计，而官方回应往往需要经过内部确认流程。速度差本身就是舆情失控的重要原因。",
        ],
      },
      {
        heading: "黄金一小时与降温机制",
        paragraphs: [
          "在情绪峰值到来之前，如果能有明确、真诚、不推诿的回应，降温效果最好。反之，含糊的声明往往会被解读为傲慢，进一步激化情绪。",
          "降温通常依靠两个机制：一是新的公共话题转移注意力，二是原始信息的补充让事实更完整。前者靠运气，后者靠准备。",
        ],
      },
    ],
  },
  {
    slug: "yinyuejie-tiyan-jingji",
    title: "音乐节的账本：票价涨了，体验为什么没跟上",
    dek: "阵容、场地、安保、周边——音乐节的成本结构正在被重估。复盘票价上涨与体验落差背后的现实约束。",
    categorySlug: "yule-guancha",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20outdoor%20music%20festival%20stage%20at%20dusk%20with%20warm%20string%20lights%20cream%20sky%2C%20amber%20and%20terracotta%20tones%2C%20minimal%20elegant%20composition&width=1200&height=800&seq=yinyuejie-cover-g7&orientation=landscape",
    author: "周叙",
    date: "2026-07-18",
    readMinutes: 7,
    tags: ["音乐节", "演出市场", "消费体验"],
    keyPoints: [
      "阵容成本是票价上涨的主要推手，头部艺人溢价明显。",
      "场地与安保成本被低估，却直接决定体验下限。",
      "周边与餐饮收入是主办方平衡账目的关键补充。",
    ],
    timeline: [
      { at: "2019 年前", text: "音乐节以小而美的区域活动为主，票价相对友好。" },
      { at: "2023 年", text: "线下演出需求集中爆发，票价快速上行。" },
      { at: "2024 年", text: "场次数量激增，同质化与体验问题集中暴露。" },
      { at: "2026 年", text: "主办方转向差异化定位，体验投入开始被重视。" },
    ],
    sections: [
      {
        heading: "阵容成本决定票价底部",
        paragraphs: [
          "音乐节的最大变量是阵容。头部艺人的演出费用在需求高峰期被显著推高，部分场次的艺人成本可以占到总支出的一半以上。",
          "当成本结构被阵容主导，票价自然难以下降。这也是为什么很多音乐节宁愿压缩其它环节，也要保住宣传层面最有吸引力的几个名字。",
        ],
      },
      {
        heading: "被低估的场地与安保",
        paragraphs: [
          "场地租金、安保配置、临时搭建与交通接驳，这些不显眼的支出，恰恰是体验的分水岭。入场排队时长、卫生间数量、补给点密度，都由它们决定。",
          "压缩这部分成本，短期账单好看，但会把不满累积到社交平台上，形成长期口碑损耗。",
        ],
      },
      {
        heading: "周边与餐饮的平衡作用",
        paragraphs: [
          "门票之外，周边商品与现场餐饮是主办方的重要收入来源。这部分利润空间更大，也常被用来对冲阵容成本的上涨。",
          "但过度依赖现场消费，容易引发对\"体验变成收费项目\"的反感。平衡点在哪里，是主办方需要长期回答的问题。",
        ],
      },
    ],
  },
  {
    slug: "pingtai-suanfa-neirong-shengtai",
    title: "算法调头之后：内容创作者的一次集体再适应",
    dek: "当分发规则从完播率转向互动与关注，创作者的选题与节奏被迫重来一遍。观察这次生态变化中的赢家与代价。",
    categorySlug: "pingtai-shengtai",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20abstract%20photography%20of%20flowing%20data%20grid%20lines%20on%20warm%20cream%20surface%2C%20soft%20light%2C%20sage%20green%20and%20terracotta%20accents%2C%20minimal%20modern%20composition&width=1200&height=800&seq=suanfa-cover-h8&orientation=landscape",
    author: "江辞白",
    date: "2026-07-10",
    readMinutes: 8,
    tags: ["算法", "创作者", "平台规则"],
    keyPoints: [
      "分发目标变化会直接改写选题成本与内容节奏。",
      "关注关系被重视后，长期人设价值上升。",
      "追逐单一指标的内容，最容易在规则变化中被淘汰。",
    ],
    timeline: [
      { at: "阶段一", text: "分发以完播率为核心，短视频结构高度趋同。" },
      { at: "阶段二", text: "互动权重提升，评论区运营成为必修课。" },
      { at: "阶段三", text: "关注关系被加强，稳定人设带来更高复访。" },
      { at: "当下", text: "创作者开始重视跨平台经营与私域沉淀。" },
    ],
    sections: [
      {
        heading: "指标变了，选题就变了",
        paragraphs: [
          "当平台把互动与关注纳入更重要的权重，纯粹追求完播的结构就会失灵。那些靠标题钩子拉时长、内容却很空的做法，转化效率明显下降。",
          "创作者被迫重新思考：这条内容除了被看完，还能不能让观众留下评论、点下关注。选题因此从\"怎样更抓眼\"转向\"怎样更值得讨论\"。",
        ],
      },
      {
        heading: "长期人设的价值回升",
        paragraphs: [
          "关注关系被强化之后，稳定的人设与垂直定位重新变得划算。观众关注的不是某一条爆款，而是\"这个人接下来还会讲什么\"。",
          "这让坚持垂直方向、持续输出同一领域内容的创作者获得结构性优势，也让频繁追热点切换赛道的行为付出更高代价。",
        ],
      },
      {
        heading: "被淘汰的从来不是勤奋的人",
        paragraphs: [
          "每次规则调整，都会有一批创作者感到被抛下。但复盘下来，真正受冲击的往往是把所有筹码押在单一指标上的人。",
          "跨越规则变化的，是那些理解自己受众、愿意经营长期关系、并且有能力把内容分发到多个渠道的创作者。生态会变，这种能力不会贬值。",
        ],
      },
    ],
  },
];

export type Faq = {
  q: string;
  a: string;
};

export const faqs: Faq[] = [
  {
    q: "看料吃瓜的内容和普通娱乐八卦有什么不同？",
    a: "我们不满足于复述传闻。每篇复盘都会交代信息来源、时间线与关键节点，并说明哪些部分是已确认的事实，哪些仍是待验证的说法，让读者拥有独立判断的基础。",
  },
  {
    q: "网站的内容多久更新一次？",
    a: "深度复盘通常每两到三天更新一篇，遇到重大热点会在事件脉络基本清晰后尽快推出。每日简报则汇总当天值得关注的讨论，工作日持续更新。",
  },
  {
    q: "如何判断你们对事件的解读是否可靠？",
    a: "每篇内容都会标注可公开查证的来源方向，并尽量避免对未证实的信息下结论。如果你发现文中有事实性错误，可以通过投稿邮箱联系我们，核实后会公开更正。",
  },
  {
    q: "可以向你们提供线索或投稿吗？",
    a: "可以。我们欢迎任何有依据的线索，但需要你提供尽可能完整的原始材料，例如完整截图、原始链接与时间信息。仅凭转述的内容我们无法进入核查流程。",
  },
  {
    q: "阅读深度复盘需要付费吗？",
    a: "目前所有深度复盘均免费阅读，订阅简报也是免费的。我们更在意读者的长期信任，而不是短期的付费转化。",
  },
];

export const testimonials = [
  {
    name: "沈砚",
    role: "内容行业从业者",
    text: "做内容的人看这类复盘会很有共鸣，它讲的是现象背后的成本和规则，而不是谁跟谁又怎么了。",
  },
  {
    name: "顾言",
    role: "长期读者",
    text: "时间线那部分我很喜欢，一件事被拉直了看，很多当时想不通的地方就顺了。",
  },
  {
    name: "何知远",
    role: "媒体研究者",
    text: "难得的是它对不确定性很克制，明确区分了事实和推测，这在信息流里已经很少见了。",
  },
];

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((item) => item.slug === slug);
}

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((item) => item.slug === slug);
}

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((item) => item.categorySlug === slug);
}